import { useCallback } from 'react';

import DailyBonus from '../features/rewards/daily/dailyBonusV2/DailyBonus';
import { useStores } from '../stores/useStores';

export function useOpenDailyBonus(persistent: boolean = false) {
  const { portalStore, rewardsStore, featureManagerStore } = useStores();

  const openDailyBonus = useCallback(() => {
    if (rewardsStore.dailyBonus) {
      portalStore.openPortal(DailyBonus, {
        persistent,
        openSoundEffect: 'daily-bonus-open',
        type: 'dailyBonus',
        beforeClose: () => {
          featureManagerStore.onDialogFinished('DailyBonus');
        },
      });
    }
  }, [persistent, portalStore, rewardsStore, featureManagerStore]);

  return { openDailyBonus };
}
